import { XIcon } from 'lucide-react';
import React from 'react';

import { ConditionalRender, Skeleton } from '@crossnokaye/ux-common';

import { SummaryConfig } from '@repo/sdk/models/components';

import { DeviceIcon } from '@/components/device-icon/device-icon';
import { PrevNextButtons } from '@/features/equipment-browser/equipment-details/page-header/prev-next-buttons';
import { Button } from '@/ux-common/components/button/button';
import {
  Header,
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
} from '@/ux-common/components/header/header';
import { Inline } from '@/ux-common/components/inline/inline';
import { withTooltip } from '@/ux-common/components/tooltip/with-tooltip';
import { Typography } from '@/ux-common/components/typography/typography';

import { JumpToEquipmentMobileMenu } from './jump-to-mobile-menu/jump-to-equipment-mobile-menu';

const TypographyWithTooltip = withTooltip(Typography);

interface EquipmentDetailsViewProps {
  equipment?: SummaryConfig;
  isLoading?: boolean;
  onClose: () => void;
}

export const EquipmentDetailsPageHeader = ({
  equipment,
  isLoading,
  onClose,
}: EquipmentDetailsViewProps): React.ReactNode => {
  // TODO: <HeaderIcon className="pl-thin"> the pl-thin below is a hack until we adjust the page template + page top nav to include a'thin gutter';
  return (
    <ConditionalRender condition={!isLoading && !!equipment} fallback={<Skeletons />}>
      <Header>
        <HeaderIcon className="pl-thin">
          <DeviceIcon deviceId={equipment!.referenceId} icon={equipment!.deviceIcon} size="lg" />
        </HeaderIcon>
        <HeaderTitle>
          <TypographyWithTooltip
            as="h1"
            className="text-page-header truncate"
            tooltipArrow
            tooltipContent={equipment!.title}
          >
            {equipment!.title}
          </TypographyWithTooltip>
        </HeaderTitle>
        <HeaderActions>
          <PrevNextButtons
            className="hidden @2xl/sidebar:flex @2xl/sidebar:mr-2"
            isLoading={isLoading}
          />
          <JumpToEquipmentMobileMenu className="flex @2xl/sidebar:hidden" />
          <Button
            className="btn btn-tier2 btn-md btn-circle"
            onClick={onClose}
            aria-label="Close equipment details"
          >
            <XIcon className="btn-icon" aria-hidden="true" />
          </Button>
        </HeaderActions>
      </Header>
    </ConditionalRender>
  );
};

const Skeletons = () => {
  return (
    <Header>
      <HeaderIcon>
        <Skeleton className="w-10 h-9" />
      </HeaderIcon>
      <HeaderTitle>
        <Skeleton className="w-40 h-9" />
      </HeaderTitle>
      <HeaderActions>
        <Inline className="h-9">
          <PrevNextButtons className="hidden @2xl/sidebar:flex" isLoading={true} />
          <Skeleton className="w-10 h-10" />
        </Inline>
      </HeaderActions>
    </Header>
  );
};
